module.exports = __webpack_public_path__ + "static/media/mali_belgium.6b7209c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/mali_belgium.jpg
// module id = 457
// module chunks = 0